import React, { useState, useRef, useEffect } from 'react';
import { serverURL } from '../constants';
import axios from 'axios';
import Loader from '../components/loader';
import favicon from '../res/img/favicon.ico';
import { Navbar } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import '../i18n'; // Import the i18n configuration

const AiModal = ({ courseTopic }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const messagesEndRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const { t, i18n } = useTranslation();

  const toggleModal = () => setIsOpen(!isOpen);
  const handleInputChange = (e) => setInputValue(e.target.value);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(scrollToBottom, [messages]);

  const removeAsterisks = (text) => {
    return text.replace(/\*/g, '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (inputValue.trim() === '') return;

    let prompt = "You are expert in teaching , answer the query precisely in chinese language.Strictly don't  use * or asterisk in response, strictly respond in html,css format  only and strictly  do not add  '```html' in response . Don't use h1, h2, h3 tags strictly . Use bold for highlights and title. If asked for your inro then call    'Learnooza AI'";

    // Reverse the order of messages
    const reversedMessages = [...messages].reverse();

    const jsonStructure = JSON.stringify({
      query: inputValue,
      prompt: prompt,
      chatHistory: reversedMessages.filter(message => message.type === 'ai')
    });

    console.log(jsonStructure);

    const userMessage = { type: 'user', content: inputValue };
    setMessages((prevMessages) => [...prevMessages, userMessage]);
    setInputValue('');
    setIsLoading(true);

    try {
      const postURL = serverURL + '/api/gpt-prompt';
      const dataToSend = { prompt: jsonStructure }; // Adjust the data structure according to your API requirements
      const res = await axios.post(postURL, dataToSend);
      const generatedText = res.data.generatedText;

      const aiMessage = { type: 'ai', content: generatedText };
      setMessages((prevMessages) => [...prevMessages, aiMessage]);
    } catch (error) {
      console.error('Error fetching AI response:', error);
      // Optionally, handle the error in the UI
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Navbar.Link
        onClick={toggleModal}
        className='text-center border-b-0 text-white font-normal bg-black dark:text-black dark:bg-white hover:bg-black dark:hover:bg-white md:dark:hover:bg-white md:hover:bg-black hover:text-white md:hover:text-white dark:hover:text-black dark:md:hover:text-black'
        style={{ paddingLeft: '15px', paddingRight: '15px', paddingBottom: '10px', paddingTop: '10px' }}
      >
        {t('general_learning_ai')}
      </Navbar.Link>

      {/* Modal */}
      {isOpen && (
        <div className="fixed bottom-20 right-4 z-50">
          <div className="bg-white rounded shadow-lg overflow-hidden relative" style={{ width: '350px' }}>
            {/* Modal Header */}
            <div className="bg-black text-white px-4 py-2 flex justify-between items-center">
              <h3 className="font-medium text-sm text-white">Chat with {t('learnooza_ai')}!</h3>
              <button
                onClick={toggleModal}
                className="text-white focus:outline-none"
                aria-label="Close"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>

            {/* Chat Messages Container */}
            <div className="overflow-y-auto p-4" style={{ height: '320px', minHeight: '320px', maxHeight: '320px' }}>
              {messages.length === 0 ? (
                <div className="text-gray-700 mb-4">
                  <p className="text-sm">Hey there! I'm your AI teacher. If you have any questions about your course, whether it's about videos, images, or theory, just ask me. I'm here to clear your doubts.</p>
                </div>
              ) : (
                messages.map((message, index) => (
                  <div key={index} className="mb-4">
                    {message.type === 'user' ? (
                      <div className="bg-black text-white p-2 rounded-md text-sm inline-block">
                        {message.content}
                      </div>
                    ) : (
                      <div className="text-gray-800 text-sm">
                        <div dangerouslySetInnerHTML={{ __html: removeAsterisks(message.content) }} />
                      </div>
                    )}
                  </div>
                ))
              )}
              <div ref={messagesEndRef} />
            </div>

            {/* Input Form */}
            <form onSubmit={handleSubmit} className="border-t border-gray-200 p-2 flex">
              <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                placeholder="Type your message..."
                className="flex-1 p-2 text-sm border-none focus:outline-none"
              />
              <button
                type="submit"
                className="bg-black text-white px-4 py-2 text-sm focus:outline-none"
                disabled={isLoading || inputValue.trim() === ''}
              >
                {isLoading ? (
                  <Loader />
                ) : (
                  'Send'
                )}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default AiModal;